import React, { Component } from 'react'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import DataTable from '../../../../DataTable/DataTable'
import { withTranslate } from 'react-redux-multilingual'
// import { Scrollbars } from 'react-custom-scrollbars'
import NoDataDisplay from '../../../../NoDataDisplay/NoDataDisplay'
import _ from 'lodash/core'
import { Grid, Typography } from '@material-ui/core'
// import Button from '../../../../UI/Button/Button'
// import { getCurrencyNumber } from '../../../../../helpers'
// import Aux from '../../../../../hoc/Auxiliary/Auxiliary'

class ForceRankTable extends Component {
  state = {
    adjustData: [],
    gradeData: [],
    data: [],
    filterData: [],
    adjust: [],
    chart: [],
    updateChart: [],
    valid: false,
    adjust_grade: {
      label: 'Adjust Grade',
      elementType: 'newselect',
      elementConfig: {
        type: 'text',
        placeholder: 'Adjust Grade',
        options: [],
        clearDisabled: true
      },
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null,
      showStatus: false,
      structureForIndex: [
        { field: 'no', title: this.props.translate('no'), type: 'string' },
        { field: 'emp_code', title: this.props.translate('empCode'), type: 'string' },
        { field: 'emp_name', title: this.props.translate('employeeName'), type: 'string' },
        { field: 'level_name', title: this.props.translate('level'), type: 'string' },
        { field: 'position_name', title: this.props.translate('position'), type: 'string' },
        { field: 'org_name', title: this.props.translate('organization'), type: 'string' },
        { field: 'status', title: this.props.translate('status'), type: 'string' },
        { field: 'result_score', title: this.props.translate('score'), type: 'string' },
        { field: 'grade', title: this.props.translate('grade'), type: 'string' },
        {
          field: 'adjust_grade',
          title: this.props.translate('adjust'),
          width: 200,
          render: rowData => {
            // let index = this.props.gradeOptions.findIndex(item => item.key === rowData?.grade_id)
            // let options = this.props.gradeOptions.filter(
            //   (item, i) => i === index || i === index - 1 || i === index + 1
            // )
            let options = this.props.gradeOptions
            return (
              <div>
                {rowData?.adjust_grade ? (
                  <InputGroup
                    inputType={'newselect'}
                    noMargin
                    label={''}
                    inputValue={rowData.adjust_grade}
                    configs={{ options: options, clearDisabled: true }}
                    changed={e => this.props.gradeChanged(rowData, e)}
                  />
                ) : null}
              </div>
            )
          },
          cellStyle: {
            width: 150,
            minWidth: 150
          },
          headerStyle: {
            width: 150,
            minWidth: 150
          }
        }
        // {
        //   field: 'raise_amount',
        //   title: this.props.translate('raiseAmount'),
        //   type: 'string',
        //   render: rowData => getCurrencyNumber(rowData?.raise_amount, 2)
        // },
        // { field: 'raise_%', title: this.props.translate('raise'), type: 'string' },
        // {
        //   field: 'salary',
        //   title: this.props.translate('salary'),
        //   type: 'string',
        //   render: rowData => getCurrencyNumber(rowData?.salary, 2)
        // },
        // {
        //   field: 'new_salary',
        //   title: this.props.translate('newSalary'),
        //   type: 'string',
        //   render: rowData => getCurrencyNumber(rowData?.new_salary, 2)
        // },
        // {
        //   field: 'bonus',
        //   title: this.props.translate('bonus'),
        //   type: 'string',
        //   render: rowData => getCurrencyNumber(rowData?.bonus, 2)
        // }
      ]
    }
  }

  static getDerivedStateFromProps (props, state) {
    let updateState = { ...state }
    console.log(props.showStatus, state.showStatus)
    if (props.showStatus !== state.showStatus) {
      let updateStructureForIndex = [
        { field: 'no', title: props.translate('no'), type: 'string' },
        { field: 'emp_code', title: props.translate('empCode'), type: 'string' },
        { field: 'emp_name', title: props.translate('employeeName'), type: 'string' },
        { field: 'level_name', title: props.translate('level'), type: 'string' },
        { field: 'position_name', title: props.translate('position'), type: 'string' },
        { field: 'org_name', title: props.translate('organization'), type: 'string' },
        { field: 'status', title: props.translate('status'), type: 'string' },
        { field: 'result_score', title: props.translate('score'), type: 'string' },
        { field: 'grade', title: props.translate('grade'), type: 'string' },
        {
          field: 'adjust_grade',
          title: props.translate('adjust'),
          width: 200,
          render: rowData => {
            let index = props.gradeOptions.findIndex(item => item.key === rowData?.grade_id)
            let options = props.gradeOptions.filter(
              (item, i) => i === index || i === index - 1 || i === index + 1 || i === index + 2
            )
            // let options = props.gradeOptions
            return (
              <div>
                {rowData?.adjust_grade ? (
                  <InputGroup
                    inputType={'newselect'}
                    noMargin
                    label={''}
                    inputValue={rowData.adjust_grade}
                    configs={{ options: options, clearDisabled: true }}
                    changed={e => props.gradeChanged(rowData, e)}
                  />
                ) : null}
              </div>
            )
          },
          cellStyle: {
            width: 150,
            minWidth: 150
          },
          headerStyle: {
            width: 150,
            minWidth: 150
          }
        }
      ]
      if (!props.showStatus) {
        updateStructureForIndex = updateStructureForIndex.filter(s => s?.field !== 'status')
      }
      updateState = {
        ...updateState,
        showStatus: props.showStatus,
        structureForIndex: updateStructureForIndex
      }
    }
    return updateState
  }

  gradeChanged = (rowData, e) => {
    let oldGrade = ''
    let update = this.state.adjust.map(item => {
      if (item === rowData) {
        oldGrade = item.adjust_grade
        return {
          ...item,
          adjust_grade: e.key
        }
      } else {
        return item
      }
    })

    let updateChart = this.state.updateChart.map(item => {
      if (oldGrade !== e.key) {
        if (item.adjust_grade === e.key) {
          return {
            ...item,
            total: item.total + 1
          }
        } else if (item.adjust_grade === oldGrade) {
          return {
            ...item,
            total: item.total - 1
          }
        } else {
          return item
        }
      } else {
        return item
      }
    })
    this.props.adjust_grade(updateChart)
    // this.props.valid_count(this.checkGrade())
    // validate
    let valid = true
    updateChart.map(up => {
      this.state.chart.map(ol => {
        if (up.adjust_grade === ol.adjust_grade) {
          valid = valid && up.total === ol.total
        }
        return ol
      })
      return up
    })
    this.props.dataAdjust(update)

    this.props.valid(valid)
    this.setState({
      adjust: update,
      updateChart: updateChart,
      valid: valid
    })

    this.checkGrade()
  }

  // checkGrade = () => {
  //   this.props.checkGrade = () => {
  //     return _.isEqual(this.state.chart, this.state.updateChart)
  //   }
  // }

  checkGrade = () => {
    if (this.props.checkGrade) {
      let checkGrade = _.isEqual(this.state.chart, this.state.updateChart)
      this.props.checkGrade(checkGrade)
    }
  }

  structureForIndex = [
    { field: 'no', title: this.props.translate('no'), type: 'string' },
    { field: 'emp_code', title: this.props.translate('empCode'), type: 'string' },
    { field: 'emp_name', title: this.props.translate('employeeName'), type: 'string' },
    { field: 'level_name', title: this.props.translate('level'), type: 'string' },
    { field: 'position_name', title: this.props.translate('position'), type: 'string' },
    { field: 'org_name', title: this.props.translate('organization'), type: 'string' },
    { field: 'status', title: this.props.translate('status'), type: 'string' },
    { field: 'result_score', title: this.props.translate('score'), type: 'string' },
    { field: 'grade', title: this.props.translate('grade'), type: 'string' },
    {
      field: 'adjust_grade',
      title: this.props.translate('adjust'),
      width: 200,
      render: rowData => {
        // let index = this.props.gradeOptions.findIndex(item => item.key === rowData?.grade_id)
        // let options = this.props.gradeOptions.filter(
        //   (item, i) => i === index || i === index - 1 || i === index + 1
        // )
        let options = this.props.gradeOptions
        return (
          <div>
            {rowData?.adjust_grade ? (
              <InputGroup
                inputType={'newselect'}
                noMargin
                label={''}
                inputValue={rowData.adjust_grade}
                configs={{ options: options, clearDisabled: true }}
                changed={e => this.props.gradeChanged(rowData, e)}
              />
            ) : null}
          </div>
        )
      },
      cellStyle: {
        width: 150,
        minWidth: 150
      },
      headerStyle: {
        width: 150,
        minWidth: 150
      }
    }
    // {
    //   field: 'raise_amount',
    //   title: this.props.translate('raiseAmount'),
    //   type: 'string',
    //   render: rowData => getCurrencyNumber(rowData?.raise_amount, 2)
    // },
    // { field: 'raise_%', title: this.props.translate('raise'), type: 'string' },
    // {
    //   field: 'salary',
    //   title: this.props.translate('salary'),
    //   type: 'string',
    //   render: rowData => getCurrencyNumber(rowData?.salary, 2)
    // },
    // {
    //   field: 'new_salary',
    //   title: this.props.translate('newSalary'),
    //   type: 'string',
    //   render: rowData => getCurrencyNumber(rowData?.new_salary, 2)
    // },
    // {
    //   field: 'bonus',
    //   title: this.props.translate('bonus'),
    //   type: 'string',
    //   render: rowData => getCurrencyNumber(rowData?.bonus, 2)
    // }
  ]

  render () {
    let table = <NoDataDisplay />
    let errorText =
      this.props.totalAdjust.length > 0
        ? `ระบุเกรดไม่ถูกต้อง ( ${this.props.totalAdjust.toString()} )`
        : null
    if (this.props.data.length !== 0) {
      table = (
        <DataTable
          data={this.props.data}
          components={'asdasdad'}
          loading={this.props.tableLoading}
          tableTitle={
            <Grid container alignItems={'center'} spacing={2}>
              <Grid item>
                <Typography variant={'h6'}>{this.props.translate('adjustGradeTable')}</Typography>
              </Grid>
              {/* <Grid item>
                <Button color={'primary'} clicked={this.props.calculateClicked}>
                  {this.props.translate('calculate')}
                </Button>
              </Grid> */}
            </Grid>
          }
          structure={this.state.structureForIndex}
          paginationDisabled={true}
          errorText={errorText}
          options={{ headerStyle: { position: 'sticky', top: 0 }, maxBodyHeight: '400px' }}
          // rowActions={this.rowActions}
        />
      )
    }

    return (
      // <Scrollbars
      //   thumbSize={45}
      //   thumbMinSize={50}
      //   autoHide
      //   style={{ height: '400px', maxHeight: '400px' }}>
      <div>{table}</div>
      // </Scrollbars>
    )
  }
}

export default withTranslate(ForceRankTable)
